import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-2-back-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_18 = { class: "setting-data" }
const _hoisted_19 = { class: "row align-items-center" }
const _hoisted_20 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_21 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "table" }
const _hoisted_24 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_25 = { class: "d-block my-3" }
const _hoisted_26 = { class: "d-none d-md-block" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "5" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = { class: "d-none d-md-block" }
const _hoisted_35 = ["onClick", "title"]
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_40 = { style: {"padding":"5px 0"} }
const _hoisted_41 = { class: "bold" }
const _hoisted_42 = ["onClick", "title"]
const _hoisted_43 = { style: {"padding":"5px 0"} }
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = {
  key: 0,
  class: "bi bi-cash-stack"
}
const _hoisted_48 = {
  key: 1,
  class: "bi bi-phone-vibrate-fill"
}
const _hoisted_49 = {
  key: 2,
  class: "bi bi-wallet-fill"
}
const _hoisted_50 = { style: {"padding":"5px 0"} }
const _hoisted_51 = { class: "bold" }
const _hoisted_52 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_54 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_60 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_61 = { class: "d-none t-d-md-table-cell" }
const _hoisted_62 = {
  key: 0,
  class: "bi bi-cash-stack"
}
const _hoisted_63 = {
  key: 1,
  class: "bi bi-phone-vibrate-fill"
}
const _hoisted_64 = {
  key: 2,
  class: "bi bi-wallet-fill"
}
const _hoisted_65 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_66 = { class: "d-none t-d-md-table-cell" }
const _hoisted_67 = { class: "sett-small-menu align-right" }
const _hoisted_68 = { class: "discl-menu dropdown" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_70 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_76 = { class: "col-md-6 col-sm-12" }
const _hoisted_77 = { class: "area-info" }
const _hoisted_78 = { class: "col-md-6 col-sm-12" }
const _hoisted_79 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_SalesOrderPaytModal = _resolveComponent("SalesOrderPaytModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.payts_by_order), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              (_ctx.isStillLoading)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_RouterLink, { to: "/app/sales/payments/list" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("  " + _toDisplayString(_ctx.language.order_nbr) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getOrderInfo.nOrder), 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.language.customer) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getOrderInfo.cltName), 1),
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.language.total_amt) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers( _ctx.getOrderInfo.orderAmt )), 1),
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.language.paid_amt) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.getOrderInfo.paidAmt)), 1),
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.language.balance) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.getOrderInfo.balanace)), 1),
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_payt_by_order_msg), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.language.payts_by_order), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addPaytRecord(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstSalesPayments.length == 0,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.printListItems && _ctx.printListItems(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_22)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_23, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.language.payts_by_order), 1)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.language.payt_nbr), 1)
                  ]),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.date), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.type), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.amount), 1),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstSalesPayments.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesDet) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesDet.OrderPaytKey
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addPaytRecord(1, salesDet)),
                          title: _ctx.language.preview
                        }, _toDisplayString(salesDet.ReceiptNbr) + "  ", 9, _hoisted_35),
                        _createTextVNode("  "),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.printReceipt(salesDet)),
                          class: "txt-black",
                          title: _ctx.language.print_receipt
                        }, _hoisted_38, 8, _hoisted_36)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.language.payt_nbr) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addPaytRecord(1, salesDet)),
                              title: _ctx.language.preview
                            }, _toDisplayString(salesDet.ReceiptNbr), 9, _hoisted_42),
                            _createTextVNode("  ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.language.date) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(salesDet.PaytDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.type) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            (salesDet.PaytType == 0)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_47))
                              : _createCommentVNode("", true),
                            (salesDet.PaytType == 1)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_48))
                              : _createCommentVNode("", true),
                            (salesDet.PaytType == 2)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_49))
                              : _createCommentVNode("", true),
                            _createTextVNode("   " + _toDisplayString(_ctx.paytTypes[salesDet.PaytType].label), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.language.amount) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.AmtPaid)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addPaytRecord(1, salesDet))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_55),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deletePaytRecord(salesDet))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_56),
                            _hoisted_57,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.printReceipt(salesDet))
                            }, [
                              _hoisted_59,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                            ], 8, _hoisted_58)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.appFxs.formatDate(salesDet.PaytDate)), 1),
                    _createElementVNode("td", _hoisted_61, [
                      (salesDet.PaytType == 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                        : _createCommentVNode("", true),
                      (salesDet.PaytType == 1)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_63))
                        : _createCommentVNode("", true),
                      (salesDet.PaytType == 2)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_64))
                        : _createCommentVNode("", true),
                      _createTextVNode("   " + _toDisplayString(_ctx.paytTypes[salesDet.PaytType].label), 1)
                    ]),
                    _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.AmtPaid)), 1),
                    _createElementVNode("td", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("span", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("ul", _hoisted_70, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.addPaytRecord(1, salesDet))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_71)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deletePaytRecord(salesDet))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_72)
                            ]),
                            _hoisted_73,
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.printReceipt(salesDet))
                              }, [
                                _hoisted_75,
                                _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                              ], 8, _hoisted_74)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstSalesPayments.length==0}])
            }, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstSalesPayments.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("nav", _hoisted_79, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_SalesOrderPaytModal, {
        visible: _ctx.isSalesPaytVis,
        initialValues: _ctx.salesPaytInitVals,
        recordStatus: _ctx.salesPaytRecStatus,
        remainingAmt: _ctx.salesRemAmt,
        onCloseForm: _ctx.onClosePaytModal,
        populateData: true
      }, null, 8, ["visible", "initialValues", "recordStatus", "remainingAmt", "onCloseForm"])
    ]))
  ], 64))
}